export const members: readonly any[] = [
    {
        id: 1,
        name: 'XL AB Travel',
        details: [
            {
                address: 'Armscor Building, 370, Nossob street, Erasmuskloof, Ext 4, Pretoria',
                phone: '083 655 6702',
                province: 'Gauteng',
                lat: '-25.81297491117846',
                long: '28.259979625680874',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-38.png?v=3',
    },

    {
        id: 2,
        name: 'XL Absolut Travel',
        details: [
            {
                address: 'Greenford Office Estate, Block E, Punters Way, Kenilworth, Cape Town, 7745',
                phone: '021 671 4666',
                province: 'Western Cape',
                lat: '-33.9899644776343',
                long: '18.487718098982953',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-01.png?v=3',
    },
    {
        id: 3,
        name: 'XL Aerocity Travel',
        details: [
            {
                address: '14 Brabazon Ave, Kempton Park, 1619',
                phone: '0860 100 800',
                province: 'Gauteng',
                lat: '-26.13419',
                long: '28.19591',
            },
        ],
        urlName: 'www.aerocitytravel.co.za',
        url: 'https://www.aerocitytravel.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-03.png?v=3',
    },
    {
        id: 4,
        name: 'XL Aloe Travel',
        details: [
            {
                address: '59 Frere Rd, Vincent, East London, 5217',
                phone: '043 709 6600',
                province: 'Eastern Cape',
                lat: '-32.98169127667062',
                long: '27.902563670108453',
            },
        ],
        urlName: 'www.aloetravel.co.za',
        url: 'https://aloetravel.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-04.png?v=3',
    },
    {
        id: 5,
        name: 'XL Astra Travel',
        details: [
            {
                address: '3 Arboretum Ave, Bloemfontein, 9301, South Africa',
                phone: '051 447 6352',
                province: 'Free State',
                lat: '-29.10663254435766',
                long: '26.21302186811667',
            },
            {
                address: '19 A D’Arcy Street Kimberley Northern Cape',
                phone: '053 832 1292',
                province: 'Northern Cape',
                lat: '-28.741090548661028',
                long: '24.769232283173565',
            },
            {
                address: 'Unit 02, 35 Blackburrow Road ,Hayfields',
                phone: '033 346 1157',
                province: 'KwaZulu-Natal',
                lat: '-29.622555917114056',
                long: '30.409221154368865',
            },
            {
                address: '68 Hurd Street, Port Elizabeth, 6045',
                phone: '041 398 2000',
                province: 'Eastern Cape',
                lat: '-33.94984067739505',
                long: '25.563972539188224',
            },
            {
                address: 'Cachetpark, Shop 8, 75 Steve Biko street, Bult, Potchefstroom 2531',
                phone: '018 297 6594',
                province: 'North West',
                lat: '-26.692078206085025',
                long: '27.094790135540045',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-05.png?v=3',
    },
    {
        id: 6,
        name: 'XL Algoa Bay Travel',
        details: [
            {
                address: '34, 4th Avenue Newton Park Port Elizabeth 6057',
                phone: '041 360 9409',
                province: 'Eastern Cape',
                lat: '-33.94441726611981',
                long: '25.56676381247315',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-02.png?v=3',
    },
    {
        id: 7,
        name: 'XL Bay Travel',
        details: [
            {
                address: '34, 4th Avenue Newton Park Port Elizabeth 6057',
                phone: '041 360 9409',
                province: 'Eastern Cape',
                lat: '-33.944390564843744',
                long: '25.56675308363716',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-06.png?v=3',
    },
    {
        id: 8,
        name: 'XL Birnam Travel',
        details: [
            {
                address: '218 Corlett Drive, Bramley, 2090',
                phone: '011 887 2062',
                province: 'Gauteng',
                lat: '-26.126273487832545',
                long: '28.083552354526482',
            },
        ],
        province: 'Gauteng',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-07.png?v=3',
    },
    {
        id: 9,
        name: 'XL Boksburg Travel',
        details: [
            {
                address: '240 Rondebult Rd, Libradene, Boksburg, 1459',
                phone: '011 297 6594',
                province: 'Gauteng',
                lat: '-26.24254568586081',
                long: '28.24705814103828',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-09.png?v=3',
    },
    {
        id: 10,
        name: 'XL Boland Travel',
        details: [
            {
                address:
                    'Unit D06A 3rd Floor, La Concorde, 57 Main Road, Paarl, 7646',
                phone: '021 872 1581',
                province: 'Western Cape',
                lat: '-33.76182426185034',
                long: '18.96223939712226',
            },
        ],
        urlName: 'www.bolandtravel.co.za',
        url: 'https://bolandtravel.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-08.png?v=3',
    },
    {
        id: 11,
        name: 'XL Bundu Bashers Travel',
        details: [
            {
                address: '64 Main Street, Howick, 3290, South Africa',
                phone: '033 330 6176',
                province: 'KwaZulu-Natal',
                lat: '-29.481505824856917',
                long: '30.229349268129692',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-10.png?v=3',
    },
    {
        id: 12,
        name: 'XL City Of Choice Travel',
        details: [
            {
                address: '277 Main Road, Malvern, Queensburgh , 4093',
                phone: '086 087 2835',
                province: 'KwaZulu-Natal',
                lat: '-29.87538231645077',
                long: '30.91080852581537',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-39.png?v=3',
    },
    {
        id: 13,
        name: 'XL Columbia Travel',
        details: [
            {
                address: '4 Kent Park Estate, 7 Kent Road Dunkeld West , 2196',
                phone: '082 820 5621',
                province: 'Gauteng',
                lat: '-26.131855862581958',
                long: '28.03274999685471',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-40.png?v=3',
    },
    {
        id: 14,
        name: 'XL Elite Travel',
        details: [
            {
                address: '131 Pretoria Rd, Rynfield, Johannesburg, 1500',
                phone: '011 849 4111',
                province: 'Gauteng',
                lat: '-26.15227201534423',
                long: '28.33804805452748',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-11.png?v=3',
    },
    {
        id: 15,
        name: 'XL Embassy Travel',
        details: [
            {
                address:
                    '17 Wale Street, Cape Town City Centre, Cape Town, 8000, South Africa',
                phone: '021 424 1111',
                province: 'Western Cape',
                lat: '-33.9233630182851',
                long: '18.417675524112465',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-12.png?v=3',
    },
    {
        id: 16,
        name: 'XL Fairmount World Travel',
        details: [
            {
                address: '16A Garden Road, Orchards, Johannesburg',
                phone: '011 640 3059',
                province: 'Gauteng',
                lat: '-26.15514596308364',
                long: '28.0744062121995',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-13.png?v=3',
    },
    {
        id: 17,
        name: 'XL Feizhong Travel',
        details: [
            {
                address: '36 Hettie Street Cyrildene Johannesburg 2198',
                phone: '082 444 9708',
                province: 'Gauteng',
                lat: '-26.175971978271853',
                long: '28.10285079685629',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-41.png?v=3',
    },
    {
        id: 18,
        name: 'XL Fly Now Travel',
        address: '31 Lilian Road, Fordsburg, Johannesburg, 2033',
        details: [
            {
                address: '31 Lilian Road, Fordsburg, Johannesburg, 2033',
                phone: '011 834 4861',
                province: 'Gauteng',
                lat: '-26.206448213082584',
                long: '28.0223906833651',
            },
            {
                address: '38 Central Street, Houghton, Johannesburg, 2198',
                phone: '011 728 5501',
                province: 'Gauteng',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-14.png?v=3',
    },
    {
        id: 19,
        name: 'XL Flywell Travel',
        details: [
            {
                address: '171 – 7th Avenue Mayfair 2092',
                phone: '011 830 15009',
                province: 'Gauteng',
                lat: '-26.204224731981487',
                long: '28.01902036802107',
            },
            {
                address: 'Cnr Bath and Ottery Road Wynberg Cape Town',
                phone: '021 761 5044',
                province: 'Western Cape',
                lat: '-34.011670846496855',
                long: '18.47868464024392',
            },
            {
                address: '271 9th Avenue Laudium Pretoria 0037',
                phone: '012 374 2041',
                province: 'Gauteng',
                lat: '-25.78726012770771',
                long: '28.10453919657331',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-15.png?v=3',
    },
    {
        id: 20,
        name: 'XL Glenwood Travel',
        details: [
            {
                address: '181 Main Road Hermanus 7200',
                phone: '028 312 3702',
                province: 'Western Cape',
                lat: '-34.416500707236665',
                long: '19.245152498999584',
            },
            {
                address: 'Menlyn Maine Central Square, Waterkloof Glen, Pretoria, 0081',
                phone: '012 941 9900',
                province: 'Gauteng',
                lat: '-25.784883068486266',
                long: '28.281156128505234',
            },
        ],
        urlName: 'www.glenwoodtravel.co.za/',
        url: 'https://glenwoodtravel.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-16.png?v=3',
    },
    {
        id: 21,
        name: 'XL Halloworld Travel',
        details: [
            {
                address: 'Unit 1, Lidwala House, 39 Ehmke St, Nelspruit, 1200',
                phone: '013 757 0883',
                province: 'Mpumalanga',
                lat: '-25.477878397330663',
                long: '30.984714212178382',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-17.png?v=3',
    },
    {
        id: 22,
        name: 'XL Highway Travel',
        details: [
            {
                address: '5 Fair Oaks 230 Willson Street Fairland 2170',
                phone: '084 462 0045',
                province: 'Gauteng',
                lat: '-26.128115492729727',
                long: '27.952613210346737',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-42.png?v=3',
    },
    {
        id: 23,
        name: 'XL Holiday Travel',
        details: [
            {
                address:
                    '10th Floor, Fredman Towers, 13 Fredman Drive Sandton Gauteng 2010 South Africa',
                phone: '087 110 0202',
                province: 'Gauteng',
                lat: '-26.10132791833731',
                long: '28.054462712197765',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-43.png?v=3',
    },
    {
        id: 24,
        name: 'XL Howick Travel CC',
        details: [
            {
                address: '64 Main Street, Howick, 3290, South Africa',
                phone: '033 330 2193',
                province: 'KwaZulu-Natal',
                lat: '-29.481505824856917',
                long: '30.229349268129692',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-18.png?v=3',
    },
    {
        id: 25,
        name: 'XL IGO Travel',
        details: [
            {
                address: '45 Jupiter Road Westville 3629',
                phone: '031 000 1122',
                province: 'KwaZulu-Natal',
                lat: '-29.812094368554863',
                long: '30.899415139305177',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-49.png?v=3',
    },
    {
        id: 26,
        name: 'XL International Travels',
        details: [
            {
                address: '149 Jan Smuts Ave, Johannesburg, 2193',
                phone: '011 447 8300',
                province: 'Gauteng',
                lat: '-26.150755603976517',
                long: '28.033244854527332',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-19.png?v=3',
    },
    {
        id: 27,
        name: 'XL Kaltravel',
        details: [
            {
                address: 'Unit b2a Meyrickton Park, 2 Meyrickton Place, Hillcrest, Kwazulu-Natal',
                phone: '031 765 3861',
                province: 'KwaZulu-Natal',
                lat: '-29.788887027387673',
                long: '30.777660006218323',
            },
        ],
        urlName: 'www.kaltravel.co.za',
        url: 'https://kaltravel.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL KALTRAVEL LOGO- TRANSPARENT BG 2.png?v=1',
    },
    {
        id: 28,
        name: 'XL Millennium Travel',
        details: [
            {
                address:
                    'Unit G04, Rostra Building, The forum, North Bank Lane, Century City, Cape Town',
                phone: '021 590 7900/03',
                province: 'Western Cape',
                lat: '-33.89261308576223',
                long: '18.507182383635193',
            },
            {
                address: '112a Boeing Rd, Bedfordview',
                phone: '011 453 1401',
                province: 'Gauteng',
                lat: '-26.162446984448557',
                long: '28.15147264075896',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-20.png?v=3',
    },
    {
        id: 29,
        name: 'XL Montana Travel',
        details: [
            {
                address: 'Shop 18 Montana Corner Centre Sefako Makgatho Dr',
                phone: '',
                province: 'Gauteng',
                lat: '-25.679775269762825',
                long: '28.24096116985677',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-46.png?v=3',
    },
    {
        id: 30,
        name: 'XL Nexus Travel',
        details: [
            {
                address: '52 Engelwold Drive, Saxonwold, Johannesburg',
                phone: '011 486 9000',
                province: 'Gauteng',
                lat: '-26.160437581131905',
                long: '28.046772269871717',
            },
            {
                address: 'ATNS In House Bedfordview',
                phone: '011 607 1246',
                province: 'Gauteng',
                lat: '-26.176915719554316',
                long: '28.11174018770163',
            },
            {
                address: '190 Florida Road, Morningside, Durban',
                phone: '031 303 4341',
                province: 'KwaZulu-Natal',
                lat: '-29.831848489474673',
                long: '31.016201883211064',
            },
            {
                address:
                    'Unit 17, Hatfield Bridge Office Park, 213 Richard Street, Hatfield',
                phone: '012 342 1245',
                province: 'Gauteng',
                lat: '-25.74289002105305',
                long: '28.244135569580802',
            },
            {
                address: '43 Lady Grey Street, Paarl, 7646',
                phone: '021 872 1994/5',
                province: 'Western Cape',
                lat: '-33.73089772903581',
                long: '18.963462896849233',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-21.png?v=3',
    },
    {
        id: 31,
        name: 'XL Non-Stop Travel',
        details: [
            {
                address: 'Suite 201, Richefond Circle, Ridgeside office park, Umhlanga, 4051',
                phone: '',
                province: 'KwaZulu-Natal',
                lat: '-29.734446548256233',
                long: '31.070169683482444',
            },
        ],
        country: 'South Africa',
        logoUrl: '/assets/xltravel/members/XL-non-stop-logo.png?v=1',
    },
    {
        id: 32,
        name: 'XL Novo Mundo Travel',
        details: [
            {
                address: '11 Ernest Oppenheimer Ave, Johannesburg, 2198',
                phone: '011 622 6313',
                province: 'Gauteng',
                lat: '-26.181373187638755',
                long: '28.106154410348452',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-22.png?v=3',
    },
    {
        id: 33,
        name: 'XL Ocean Air Travel',
        details: [
            {
                address: '26 Willow Road Bloubergrise Cape Town 7441',
                phone: '021 556 8083',
                province: 'Western Cape',
                lat: '-33.81107050090172',
                long: '18.484970325960198',
            },
            {
                address: '151 Musgrave Rd, Berea, 4001, South Africa',
                phone: '031 202 6900',
                province: 'Gauteng',
                lat: '-29.847778239340357',
                long: '30.999801623698275',
            },
            {
                address: '2 Rhodes St, Randburg, 2194, South Africa',
                phone: '011 772 1100',
                province: 'Gauteng',
                lat: '-26.082910700092743',
                long: '28.00637522357374',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-23.png?v=3',
    },
    {
        id: 34,
        name: 'XL Olebelo Travel',
        details: [
            {
                address: '1 Saxon Road, Hyde Park, Sandton',
                phone: '076 584 0230',
                province: 'Gauteng',
                lat: '-26.115190473557245',
                long: '28.032335454526322',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-44.png?v=3',
    },
    {
        id: 35,
        name: 'XL Plettenberg Bay Travel',
        details: [
            {
                address:
                    'Shop 1 Florina Place ,Cnr. Main street and, Gibb St, Plettenberg Bay, 6600',
                phone: '044 533 0484',
                province: 'Western Cape',
                lat: '-34.03700256386097',
                long: '23.375198312974554',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-24.png?v=3',
    },
    {
        id: 36,
        name: 'XL Sandown Travel',
        details: [
            {
                address: '47 Linksfield Road Dowerglen Edenvale, 1609',
                phone: '011 453 2660',
                province: 'Gauteng',
                lat: '-26.150026933302453',
                long: '28.14233901219928',
            },
            {
                address:
                    'Millenium Business Park Edison Way Century City Cape Town',
                phone: '021 000 0350',
                province: 'Western Cape',
                lat: '-33.881129111635836',
                long: '18.520175139185476',
            },
            {
                address: 'B 34, Banking Mall, Sandton Dr, Sandton, 2146',
                phone: '011 506 5600',
                province: 'Gauteng',
                lat: '-26.10974707366639',
                long: '28.053377864067066',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-25.png?v=3',
    },
    {
        id: 37,
        name: 'XL Select Travel',
        details: [
            {
                address: '354 Hippo ave, Zwartkop, Centurion',
                phone: '012 346 6404',
                province: 'Gauteng',
                lat: '-25.859242095710183',
                long: '28.17652851033815',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-26.png?v=3',
    },
    {
        id: 38,
        name: 'XL Skyways Travel',
        details: [
            {
                address:
                    'Plot 132 Independence Avenue Victora House Main Mall, Gaborone Botswana',
                phone: '+267 318 7039',
                province: 'Botswana',
                lat: '-24.654893823547628',
                long: '25.918923780926566',
            },
        ],
        country: 'Botswana',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-27.png?v=3',
    },
    {
        id: 39,
        name: 'XL Stellenbosch',
        details: [
            {
                address: '58 Bird St, Stellenbosch Central, Stellenbosch, 7599',
                phone: '021 887 2920',
                province: 'Western Cape',
                lat: '-33.93630326019402',
                long: '18.85953408061919',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-28.png?v=3',
    },
    {
        id: 40,
        name: 'XL Thompsons Travel',
        details: [
            {
                address: '6 Hood Avenue Rosebank',
                phone: '011 770 7500',
                province: 'Gauteng',
                lat: '-26.147853767882992',
                long: '28.036165996855296',
            },
            {
                address:
                    '20 The Boulevard West End Office Park Spine Road Westville 3635',
                phone: '031 275 3833',
                province: 'KwaZulu-Natal',
                lat: '-29.845421928209422',
                long: '30.92230555437665',
            },
            {
                address: 'Chiappini Sqaure 17 Chiappini Street Cape Town',
                phone: '021 408 9555',
                province: 'Western Cape',
                lat: '-33.91584027806384',
                long: '18.42092076802147',
            },
        ],
        province: 'Gauteng',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-30.png?v=3',
    }, ,
    {
        id: 41,
        name: 'XL The Travel Professionals',
        details: [
            {
                address:
                    'Hartmann Suites 22, Cnr Robert Mugabe & Ballot Street, Windhoek',
                phone: '+264 612 53528',
                province: 'Namibia',
                lat: '-22.579068692528047',
                long: '17.09250104859273',
            },
        ],
        country: 'Namibia',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-29.png?v=3',
    },
    {
        id: 42,
        name: 'XL Centurion Travel',
        details: [
            {
                address: '354 Hippo Ave, Zwartkop, Centurion, 0157',
                phone: '082 820 5621',
                province: 'Gauteng',
                lat: '-26.131855862581958',
                long: '28.03274999685471',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-31.png?v=3',
    },
    {
        id: 43,
        name: 'XL The Travel Department',
        details: [
            {
                address: '15 Fricker Rd, Illovo Boulavard, Sandton, 2196',
                phone: '011 770 6945',
                province: 'Gauteng',
                lat: '-26.132134638066383',
                long: '28.0464912968548',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-51.png?v=1.1',
    },
    {
        id: 44,
        name: 'XL Travel Eswatini',
        details: [
            {
                address: 'Shop 2, The Mall, Dr Sishayi Rd, Mbabane, Eswatini',
                phone: '+268 240 42101',
                province: 'Eswatini',
                lat: '-26.32666852022677',
                long: '31.143040788592366',
            },
        ],
        country: 'Eswatini',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-32.png?v=3',
    },

    {
        id: 45,
        name: 'XL Travel Today',
        details: [
            {
                address: '45 Ferreira St, Nelspruit, 1200',
                phone: '013 755 2146',
                province: 'Mpumalanga',
                lat: '-25.476919108837855',
                long: '30.984833096834283',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-34.png?v=3',
    },
    {
        id: 46,
        name: 'XL Traveleaders Travel Centre',
        details: [
            {
                address:
                    'Block C, Ground Floor, Edenburg Terraces, 348 Rivonia Boulevard, Rivonia',
                phone: '+27 11 807 0387',
                province: 'Gauteng',
                lat: '-26.05595798580618',
                long: '28.060769068016306',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-33.png?v=3',
    },
    {
        id: 47,
        name: 'XL Turners Travel',
        details: [
            {
                address:
                    'Unit 1 Highway Office Gardens Park Cnr Minuach & Partridge Roads Highway Gardens Edenvale',
                phone: '011 400 6300',
                province: 'Gauteng',
                lat: '-26.1453536941729',
                long: '28.179974150823394',
            },
            {
                address:
                    'Turners House, 38 Jonsson Lane, Durban',
                phone: '011 400 6300',
                province: 'KwaZulu-Natal',
                lat: '-29.86037959882343',
                long: '31.030052812046883',
            },
            {
                address:
                    'Unit 9, MS Business Park, Eastman Rd, Off Upper Camp, Maitland',
                phone: '011 400 6300',
                province: 'Western Cape',
                lat: '-33.92931325404719',
                long: '18.48062713025295',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-35.png?v=3',
    },
    {
        id: 48,
        name: 'XL Voyagers Zambia Travel',
        details: [
            {
                address: 'Plot No. 17/18, Arusha Street, Ndola',
                phone: '083 655 6702',
                province: 'Zambia',
                lat: '-12.961953789194006',
                long: '28.649241752345887',
            },
        ],
        country: 'Zambia',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-45.png?v=3.1',
    },
    {
        id: 49,
        name: 'XL Wild Travel',
        details: [
            {
                address: '19 Krige Street, Stellenbosch 7600, South Africa',
                phone: '021 886 9332',
                province: 'Western Cape',
                lat: '-33.940273456235914',
                long: '18.85641129712911',
            },
        ],
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/XL MEMBER LOGOS-37.png?v=3',
    },
    {
        id: 50,
        name: 'XL Flight Specials',
        details: [
            {
                address: '',
                phone: '',
                lat: '-26.080440358223726',
                long: '28.03217323918127',
            },
        ],
        urlName: 'www.flightspecials.co.za',
        url: 'https://www.flightspecials.co.za/',
        province: 'Gauteng',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/flight-specials.png?v=3',
    },
    {
        id: 51,
        name: 'XL GSTA',
        details: [
            {
                address: '',
                phone: '',
                province: 'Gauteng',
                lat: '-26.146983284635482',
                long: '27.96282687481073',
            },
        ],
        urlName: 'www.gsta.co.za',
        url: 'https://www.gsta.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/gsta.png?v=3',
    },
    {
        id: 52,
        name: 'XL Travel Masters',
        details: [
            {
                address: '',
                phone: '',
                province: 'Gauteng',
                lat: '',
                long: '',
            },
        ],
        urlName: 'www.xltravelmasters.co.za',
        url: 'https://xltravelmasters.co.za/',
        country: 'South Africa',
        logoUrl: 'assets/xltravel/members/xl-masters-logo.png?v=3',
    },
];
